var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavDsp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.515 3.17c.535 0 .984 0 1.352.03.385.03.75.1 1.097.277.529.27.96.699 1.23 1.228.176.347.244.713.276 1.098.03.368.03.817.03 1.352v3.011c0 .535 0 .985-.03 1.353-.032.384-.1.75-.277 1.097-.27.53-.7.96-1.23 1.23-.346.176-.711.245-1.096.276-.368.03-.817.03-1.352.03H12.29l1.56 1.247a.803.803 0 0 1-1.004 1.255L10 14.377l-2.847 2.277A.803.803 0 0 1 6.15 15.4l1.56-1.248H6.485c-.535 0-.984.001-1.352-.029-.385-.031-.75-.1-1.097-.276-.529-.27-.96-.7-1.23-1.23-.176-.347-.244-.713-.276-1.097-.03-.368-.03-.818-.03-1.353v-3.01c0-.536 0-.985.03-1.353.032-.385.1-.75.277-1.098.27-.529.7-.959 1.23-1.228.346-.177.711-.246 1.096-.278.368-.03.817-.03 1.352-.03zM5.208 5.29a.5.5 0 0 0-.5.5v5.635a.5.5 0 0 0 .5.5h9.634a.5.5 0 0 0 .5-.5V5.79a.5.5 0 0 0-.5-.5z",
  clipRule: "evenodd"
})));
SvgNavDsp.displayName = "SvgNavDsp";
export { SvgNavDsp as ReactComponent };
export default SvgNavDsp;